{
  "name": "53-(13-Limit) Taylor",
  "description": "Cam Taylor’s 53-tone 13-Limit Rational Intonation scale, consisting of 53 symmetrically derived notes per octave derived from harmonic partial row intervals up to a prime limit of 13. This 13-Limit scale demonstrates a symmetric harmonic-subharmonic construction producing a continuous chain of perfect fifths and \"quasi-fifths\". By its similarity to the other 53-tone scales found here, this version demonstrates the concept of \"rational temperament\", where enharmonically proximal ratios may substitute for missing notes as slightly mistuned alternates.",
  "scale": [
    "81/80",
    "33/32",
    "28/27",
    "256/243",
    "16/15",
    "13/12",
    "12/11",
    "10/9",
    "9/8",
    "8/7",
    "15/13",
    "7/6",
    "32/27",
    "6/5",
    "39/32",
    "16/13",
    "5/4",
    "81/64",
    "9/7",
    "13/10",
    "21/16",
    "4/3",
    "27/20",
    "11/8",
    "18/13",
    "45/32",
    "64/45",
    "13/9",
    "16/11",
    "40/27",
    "3/2",
    "32/21",
    "20/13",
    "14/9",
    "128/81",
    "8/5",
    "13/8",
    "64/39",
    "5/3",
    "27/16",
    "12/7",
    "26/15",
    "7/4",
    "16/9",
    "9/5",
    "11/6",
    "24/13",
    "15/8",
    "243/128",
    "27/14",
    "64/33",
    "160/81",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "53-RI-13L_Taylor",
  "built_in_group": "Rational Intonation (JI)",
  "key_labels": "note_names",
  "note_names": [
    "C",
    "C",
    "C",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "E",
    "E",
    "E",
    "E",
    "E",
    "E",
    "E",
    "E",
    "F",
    "F",
    "F",
    "F",
    "F",
    "F",
    "F",
    "G",
    "G",
    "G",
    "G",
    "G",
    "G",
    "G",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "B",
    "B",
    "B",
    "B",
    "B",
    "B",
    "B",
    "B",
    "B",
    "C",
    "C"
  ],
  "note_colors": [
    "#ffffff",
    "#dee2da",
    "#dfffd6",
    "#ffe5e5",
    "#d0d0d7",
    "#dee2da",
    "#e6d7fe",
    "#cee3e2",
    "#fffae5",
    "#ffffff",
    "#e2caca",
    "#e4f6fb",
    "#ffe5e5",
    "#d0d0d7",
    "#dee2da",
    "#e6d7fe",
    "#cabddb",
    "#fffae5",
    "#ffffff",
    "#e2caca",
    "#e4fbf1",
    "#ffe5e5",
    "#ffffff",
    "#dee2da",
    "#dfffd6",
    "#cabddb",
    "#fffae5",
    "#dee2da",
    "#e6d7fe",
    "#cee3e2",
    "#fffae5",
    "#ffffff",
    "#e2caca",
    "#e4f6fb",
    "#ffe5e5",
    "#d0d0d7",
    "#dee2da",
    "#e6d7fe",
    "#cabddb",
    "#fffae5",
    "#ffffff",
    "#e2caca",
    "#e4fbf1",
    "#ffe5e5",
    "#d0d0d7",
    "#dee2da",
    "#dfffd6",
    "#cabddb",
    "#fffae5",
    "#ffffff",
    "#e2caca",
    "#cee3e2",
    "#fffae5"
  ],
  "equivSteps": 53,
  "fundamental": 440,
  "reference_degree": 40,
  "center_degree": 0,
  "rSteps": 9,
  "drSteps": 4,
  "hexSize": 42,
  "rotation": -16.102113751
}
